import * as React from 'react';
import { split } from 'lodash';
import { IBoxProps } from '@lce/slice';

import PriceSymbol from './PriceSymbol';
import CentsUnderline from './CentsUnderline';
import * as Styled from './Price.style';

export interface IPriceProps extends IBoxProps {
  price: number;
  priceColor?: string;
  priceFlipped?: boolean;
  currencyImage?: string;
}

export interface IPrice {
  dollars: string;
  cents?: string;
}

export const splitPrice = (price: number): IPrice => {
  const priceArray = split(price.toFixed(2), '.');
  const dollars = priceArray[0];
  const cents = priceArray.length > 1 && priceArray[1] !== '00' ? priceArray[1] : undefined;

  return { dollars, cents };
};

export const Price: React.FC<IPriceProps> = ({ price, priceColor = 'black', priceFlipped = false, currencyImage, ...props }) => {
  const { dollars, cents } = splitPrice(price);

  return (
    <Styled.Price color={ priceColor } data-testid="Price" { ...props }>
      {!priceFlipped && <PriceSymbol currencyImage={ currencyImage }/> }
      <Styled.Dollars as="span">{ dollars }</Styled.Dollars>
      {cents && <Styled.Cents as="span">{cents}<CentsUnderline color={priceColor} /></Styled.Cents> }
      { priceFlipped && <PriceSymbol data-testid="PriceSymbol" currencyImage={ currencyImage } isCentered={ cents !== undefined } /> }
    </Styled.Price>
  );
};
